import * as React from 'react';

export type FieldValidationContextType = {
  fieldErrors: Record<number, string>;
  setFieldError: (fieldId: number, message: string) => void;
  clearFieldError: (fieldId: number) => void;
};

const defaultValue: FieldValidationContextType = {
  fieldErrors: {},
  setFieldError: () => {},
  clearFieldError: () => {},
};

export const FieldValidationContext = React.createContext<FieldValidationContextType>(defaultValue);

export const useFieldValidation = () => React.useContext(FieldValidationContext);

export const useFieldValidationState = () => {
  const [fieldErrors, setFieldErrors] = React.useState<Record<number, string>>({});

  const setFieldError = React.useCallback((fieldId: number, message: string) => {
    setFieldErrors((prev) => ({ ...prev, [fieldId]: message }));
  }, []);

  const clearFieldError = React.useCallback((fieldId: number) => {
    setFieldErrors((prev) => {
      const next = { ...prev };
      delete next[fieldId];
      return next;
    });
  }, []);

  return { fieldErrors, setFieldError, clearFieldError };
};
